// ============================================================
//  BECOOL STORKÖK — SITE CONFIGURATION
//  Edit this file to update company info across the whole site
// ============================================================

const config = {
  // Company
  name: "BeCool Storkök",
  tagline: "Kyl, Frys & Värmespecialister · Göteborg",
  description:
    "Vi på BeCool är specialister på kyla, värme och storköksmaskiner. För butik, fastighet och hushåll utför vi projektering, installation, reparation och service – snabbt, pålitligt och utan krångel.",

  // Contact
  phone: "076-304 93 84",
  phoneHref: "tel:0763049384",
  email: "info@becoolstorkok.se",
  area: "Göteborg & Västra Götaland",

  // Stats bar (homepage)
  stats: [
    { number: "15+", label: "Års erfarenhet" },
    { number: "24/7", label: "Jourlinje" },
    { number: "200+", label: "Nöjda kunder" },
    { number: "4h", label: "Målsättning utryckning" },
  ],

  // Service areas (about page)
  areas: [
    { name: "Göteborg", highlight: true },
    { name: "Mölndal" },
    { name: "Partille" },
    { name: "Härryda" },
    { name: "Lerum" },
    { name: "Alingsås" },
    { name: "Kungsbacka" },
    { name: "Kungälv" },
    { name: "Stenungsund" },
    { name: "Trollhättan" },
    { name: "Borås" },
    { name: "Varberg" },
    { name: "Västra Götaland" },
  ],

  // Brands (services page)
  brands: [
    { name: "ELECTROLUX", type: "Kyl & Frys" },
    { name: "TRUE", type: "Kyldiskar" },
    { name: "GRAM", type: "Storkylskåp" },
    { name: "ZANUSSI", type: "Kyl & Frys" },
    { name: "DANFOSS", type: "Kylteknik" },
    { name: "CARRIER", type: "Aggregat" },
    { name: "BITZER", type: "Kompressorer" },
    { name: "DAIKIN", type: "AC & Kyla" },
    { name: "PANASONIC", type: "AC-system" },
    { name: "LIEBHERR", type: "Kyl & Frys" },
    { name: "FOSTER", type: "Storkylskåp" },
    { name: "SKYRAINBOW", type: "Kyldiskar" },
  ],

  // Footer
  copyright: "© 2025 BeCool Storkök. Alla rättigheter förbehållna.",
  footerTagline: "Kyl, Frys & Värme · Göteborg",
  footerDescription:
    "Kyl-, frys- och värmespecialister för storkök, restauranger och livsmedelsföretag i Göteborg och Västra Götaland.",
};

export default config;
